import { BLOCKING_PANEL } from '../../constants.js';

export function moveBlockingPanel(newZIndex){
  return {
    type : BLOCKING_PANEL.Z_INDEX,
    zIndex : newZIndex
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_blocking_panel.js